export default __webpack_public_path__ + "static/media/Governor.5f360327.png";